import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import PaidSearchAdAgencyPage from "../pages/PaidSearchAdAgencyPage.vue";
import SocialMediaAdAgencyPage from "../pages/SocialMediaAdAgencyPage.vue";
import TraditionalOfflineAdAgencyPage from "../pages/TraditionalOfflineAdAgencyPage.vue";
import ServicesPage from "../pages/ServicesPage.vue";
import ServiceDetailsPage from "../pages/ServiceDetailsPage.vue";
import ServiceDetails1Page from "../pages/ServiceDetails1Page.vue";
import ServiceDetails2Page from "../pages/ServiceDetails2Page.vue";
import ServiceDetails3Page from "../pages/ServiceDetails3Page.vue";
import ServiceDetails4Page from "../pages/ServiceDetails4Page.vue";
import ServiceDetails5Page from "../pages/ServiceDetails5Page.vue";
import ServiceDetails6Page from "../pages/ServiceDetails6Page.vue";
import OurTeamPage from "../pages/OurTeamPage.vue";
import AboutUsPage from "../pages/AboutUsPage.vue";
import CareersPage from "../pages/CareersPage.vue";
import CareerDetailsPage from "../pages/CareerDetailsPage.vue";
import SuccessStoriesPage from "../pages/SuccessStoriesPage.vue";
import SuccessStoryDetailsPage from "../pages/SuccessStoryDetailsPage.vue";
import BlogPage from "../pages/BlogPage.vue";
import BlogDetailsPage from "../pages/BlogDetailsPage.vue";
import TagsPage from "../pages/TagsPage.vue";
import CategoriesPage from "../pages/CategoriesPage.vue";
import AuthorPage from "../pages/AuthorPage.vue";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage.vue";
import CancellationRefundPolicyPage from "../pages/CancellationRefundPolicyPage.vue";
import ShippingDeliveryPolicyPage from "../pages/ShippingDeliveryPolicyPage.vue";
import TermsConditionsPage from "../pages/TermsConditionsPage.vue";
import ContactUsPage from "../pages/ContactUsPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import OurClients from "../pages/OurClients.vue";
import Testimonial1Page from "../pages/Testimonial1Page.vue";
import Testimonial2Page from "../pages/Testimonial2Page.vue";
import Testimonial3Page from "../pages/Testimonial3Page.vue";
import Testimonial4Page from "../pages/Testimonial4Page.vue";
import Testimonial5Page from "../pages/Testimonial5Page.vue";
import Testimonial6Page from "../pages/Testimonial6Page.vue";
import TestimonialPage from "../pages/TestimonialPage.vue";
import BusinessEnquiryPage from "../pages/BusinessEnquiryPage.vue";
import GetYourWishPage from "../pages/GetYourWishPage.vue";
import AdminLogin from "../pages/AdminLogin.vue";
import AdminTeam from "../pages/AdminTeam.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/get-your-wish",
    name: "GetYourWishPage",
    component: GetYourWishPage,
  },
  {
    path: "/business-enquiry",
    name: "BusinessEnquiryPage",
    component: BusinessEnquiryPage,
  },
  {
    path: "/paid",
    name: "PaidSearchAdAgencyPage",
    component: PaidSearchAdAgencyPage,
  },
  {
    path: "/Client",
    name: "OurClients",
    component: OurClients,
  },
  {
    path: "/",
    name: "SocialMediaAdAgencyPage",
    component: SocialMediaAdAgencyPage,
  },
  {
    path: "/traditional-offline-ad-agency",
    name: "TraditionalOfflineAdAgencyPage",
    component: TraditionalOfflineAdAgencyPage,
  },
  {
    path: "/services",
    name: "ServicesPage",
    component: ServicesPage,
  },
  {
    path: "/service-details",
    name: "ServiceDetailsPage",
    component: ServiceDetailsPage,
  },
  {
    path: "/service-details-1",
    name: "ServiceDetails1Page",
    component: ServiceDetails1Page,
  },
  {
    path: "/service-details-2",
    name: "ServiceDetails2Page",
    component: ServiceDetails2Page,
  },
  {
    path: "/service-details-3",
    name: "ServiceDetails3Page",
    component: ServiceDetails3Page,
  },
  {
    path: "/service-details-4",
    name: "ServiceDetails4Page",
    component: ServiceDetails4Page,
  },
  {
    path: "/service-details-5",
    name: "ServiceDetails5Page",
    component: ServiceDetails5Page,
  },
  {
    path: "/service-details-6",
    name: "ServiceDetails6Page",
    component: ServiceDetails6Page,
  },
  {
    path: "/our-team",
    name: "OurTeamPage",
    component: OurTeamPage,
  },
  {
    path: "/about-us",
    name: "AboutUsPage",
    component: AboutUsPage,
  },
  {
    path: "/careers",
    name: "CareersPage",
    component: CareersPage,
  },
  {
    path: "/career-details",
    name: "CareerDetailsPage",
    component: CareerDetailsPage,
  },
  {
    path: "/success-stories",
    name: "SuccessStoriesPage",
    component: SuccessStoriesPage,
  },
  {
    path: "/success-story-details",
    name: "SuccessStoryDetailsPage",
    component: SuccessStoryDetailsPage,
  },
  {
    path: "/blog",
    name: "BlogPage",
    component: BlogPage,
  },
  {
    path: "/blog-details",
    name: "BlogDetailsPage",
    component: BlogDetailsPage,
  },
  {
    path: "/tags",
    name: "TagsPage",
    component: TagsPage,
  },
  {
    path: "/categories",
    name: "CategoriesPage",
    component: CategoriesPage,
  },
  {
    path: "/author",
    name: "AuthorPage",
    component: AuthorPage,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
  },
  {
    path: "/cancellation-refund-policy",
    name: "CancellationRefundPolicyPage",
    component: CancellationRefundPolicyPage,
  },
  {
    path: "/shipping-delivery-policy",
    name: "ShippingDeliveryPolicyPage",
    component: ShippingDeliveryPolicyPage,
  },
  {
    path: "/terms-conditions",
    name: "TermsConditionsPage",
    component: TermsConditionsPage,
  },
  {
    path: "/contact-us",
    name: "ContactUsPage",
    component: ContactUsPage,
  },
  {
    path: "/testimonial-1",
    name: "Testimonial1Page",
    component: Testimonial1Page,
  },
  {
    path: "/testimonial-2",
    name: "Testimonial2Page",
    component: Testimonial2Page,
  },
  {
    path: "/testimonial-3",
    name: "Testimonial3Page",
    component: Testimonial3Page,
  },
  {
    path: "/testimonial-4",
    name: "Testimonial4Page",
    component: Testimonial4Page,
  },
  {
    path: "/testimonial-5",
    name: "Testimonial5Page",
    component: Testimonial5Page,
  },
  {
    path: "/testimonial-6",
    name: "Testimonial6Page",
    component: Testimonial6Page,
  },
  {
    path: "/testimonial/:id",
    name: "TestimonialPage",
    component: TestimonialPage,
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: AdminLogin,
  },
  {
    path: "/admin/team",
    name: "AdminTeam",
    component: AdminTeam,
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
